import React from 'react';
import Header from '../../components/ui/Header';
import ScrollProgressIndicator from '../../components/ui/ScrollProgressIndicator';
import FloatingActionButton from '../../components/ui/FloatingActionButton';
import HeroSection from './components/HeroSection';
import SeminarSection from './components/SeminarSection';
import ValuePropositionSection from './components/ValuePropositionSection';
import LearningHubSection from './components/LearningHubSection';
import CoursesSection from './components/CoursesSection';
import TeamSection from './components/TeamSection';
import SuccessStoriesSection from './components/SuccessStoriesSection';
import AboutSection from './components/AboutSection';
import ApplicationSection from './components/ApplicationSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Navigation & Progress */}
      <Header />
      <ScrollProgressIndicator />
      
      {/* Main Content Sections */}
      <main>
        <HeroSection />
        <AboutSection />
        <SeminarSection />
        <ValuePropositionSection />
        <CoursesSection />
        <LearningHubSection />
        <TeamSection />
        <SuccessStoriesSection />
        <ApplicationSection />
        <ContactSection />
      </main>

      {/* Footer */}
      <Footer />

      {/* Floating Elements */}
      <FloatingActionButton />
    </div>
  );
};

export default LandingPage;